import { render, staticRenderFns } from "./ChannelIcon.vue?vue&type=template&id=16d49be4&scoped=true&"
import script from "./ChannelIcon.vue?vue&type=script&lang=js&"
export * from "./ChannelIcon.vue?vue&type=script&lang=js&"
import style0 from "./ChannelIcon.vue?vue&type=style&index=0&id=16d49be4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d49be4",
  null
  
)

export default component.exports